import type {
	BackToTopButtonVariant,
	BackToTopVariant,
} from "#/_packages/umbrella/features/back-to-top/components/back-to-top.tsx";

export function toBackToTopVariant(
	value?: string | null,
): BackToTopVariant | undefined {
	switch (value) {
		case "left":
		case "center":
		case "right":
			return value;
		default:
			return undefined;
	}
}

export function toBackToTopButtonVariant(
	value?: string | null,
): BackToTopButtonVariant | undefined {
	switch (value) {
		case "none":
		case "text":
			return value;
		default:
			return undefined;
	}
}
